import EditIcon from '@atlaskit/icon/core/edit';
import * as React from 'react';

export function SvgEdit() {
  return <EditIcon label="" testId="ads-refreshed-icon" />;
}
